import "./customInput.scss";

import classnames from "classnames";
import { useState } from "react";
import { Form, InputGroup, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useCopyToClipboard } from "usehooks-ts";

import { CopyIcon } from "../icons";

interface IProps {
  inputValue: string;
  label?: string;
  fullWidth?: boolean;
  isLoading?: boolean;
}

const CopyToClipboardInput: React.FC<IProps> = ({
  inputValue,
  label,
  fullWidth = false,
  isLoading = false,
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [_copiedText, copy] = useCopyToClipboard();

  const copyToClipboard = async () => {
    await copy(inputValue);
    setIsCopied(true);
    toast.success("Copied to clipboard!");

    setTimeout(() => {
      setIsCopied(false);
    }, 500);
  };

  const inputClassname = classnames({
    "custom-input-element": true,
    "mt-5": !label,
    rounded: true,
    "full-width": fullWidth,
    "copy-input": true,
  });

  const copyTextClassname = classnames({
    "custom-input__copy-text": true,
    "custom-input__copy-text--copied": isCopied,
  });

  const copyIconClassname = classnames({
    "custom-input-copy-icon": true,
    "svg-icon": true,
    "svg-icon-2x": !fullWidth,
    "overlay-icon": fullWidth,
  });

  return (
    <>
      {(label || isLoading) && (
        <Form.Label className="pt-5 d-block fs-7">{label}</Form.Label>
      )}
      <InputGroup className="custom-input-container custom-input___copy-container">
        <Form.Control
          className={inputClassname}
          aria-label=".form-control-sm"
          value={inputValue}
          type="text"
          size="sm"
          readOnly
        />
        <span
          className={copyTextClassname}
          onClick={copyToClipboard}
          data-testid="copy-icon"
        >
          {isLoading ? (
            <Spinner
              className="ms-2"
              size="sm"
              animation="border"
              data-testid="value-loader"
            />
          ) : (
            <CopyIcon className={copyIconClassname} size={20} />
          )}
        </span>
      </InputGroup>
    </>
  );
};

export { CopyToClipboardInput };
